export const isValidUrl = (value: string): boolean => {
  const urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // validate fragment locator
  return urlPattern.test(value);
};

export const generateRedirectingUrl = (
  url: string,
  key: string = "next",
): string => {
  // Capture the current URL so we can redirect back to it after intake
  if (window.location.pathname) {
    return (
      url +
      `?${key}=${encodeURIComponent(
        `${window.location.pathname}${window.location.search}`,
      )}`
    );
  }

  return url;
};

export const generateRedirectingIntakeUrl = (): string => {
  return generateRedirectingUrl("/intake/welcome", "redirect");
};

export const generateRedirectingLoginUrl = (): string => {
  return generateRedirectingUrl("/login", "next");
};

export const getUrlExtendingCurrentQueryParams = (
  url: string,
  params: Record<string, string>,
): string => {
  const currentUrlObj = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrlObj.search);

  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  return `${url}?${searchParams.toString()}`;
};

export const getUrlComponentsByCoalescingQueryParams = (
  urlPossiblyWithQueryParams: string,
  params: Record<string, string>,
) => {
  const urlObj = new URL(urlPossiblyWithQueryParams, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value);
  });

  return {
    pathname: urlObj.pathname,
    search: urlObj.search,
  };
};
